export default __webpack_public_path__ + "dfdf7dcbe3b86b87acb3831998ad7621.png";